import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { ArrowRight } from "lucide-react";

export default function Programmes() {
    const [items, setItems] = useState([]);
    useEffect(() => { api.get("/programmes").then((r) => setItems(r.data || [])); }, []);

    return (
        <div data-testid="programmes-page">
            <section className="pt-20 pb-12 md:pt-32 md:pb-16">
                <div className="container-hero">
                    <div className="label-eyebrow text-brand-forest mb-4">Our Programmes</div>
                    <h1 className="font-display text-5xl sm:text-6xl font-semibold leading-[1.05] max-w-3xl">
                        Six focused programmes. Built with the community. Delivered where they live.
                    </h1>
                </div>
            </section>
            <section className="pb-24 md:pb-32">
                <div className="container-hero space-y-6">
                    {items.map((p, i) => (
                        <Link
                            key={p.id}
                            to={`/programmes/${p.slug}`}
                            data-testid={`programmes-list-${p.slug}`}
                            className="group grid md:grid-cols-12 gap-6 items-stretch bg-white rounded-2xl overflow-hidden border border-black/5 hover:shadow-lg hover:-translate-y-1 transition-transform duration-300"
                        >
                            <div className={`md:col-span-5 ${i % 2 ? "md:order-2" : ""}`}>
                                <div className="h-64 md:h-full overflow-hidden">
                                    <img src={p.cover_image} alt={p.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
                                </div>
                            </div>
                            <div className="md:col-span-7 p-8 md:p-10">
                                <div className="label-eyebrow text-brand-forest mb-3">{p.tagline}</div>
                                <h2 className="font-display text-3xl md:text-4xl font-medium leading-tight">{p.title}</h2>
                                <p className="text-slate-600 mt-4 leading-relaxed">{p.summary}</p>
                                {p.description && (
                                    <p className="text-slate-500 text-sm mt-3 leading-relaxed line-clamp-3">
                                        {p.description}
                                    </p>
                                )}
                                {p.outcomes?.length > 0 && (
                                    <ul className="flex flex-wrap gap-2 mt-6">
                                        {p.outcomes.map((o) => (
                                            <li key={o} className="text-xs px-3 py-1.5 rounded-full bg-brand-stone text-slate-700">{o}</li>
                                        ))}
                                    </ul>
                                )}
                            </div>
                        </Link>
                    ))}
                </div>
            </section>
        </div>
    );
}
